import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    MultiSelectBox,
    SearchDateBox,
    SearchBox,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
    Modal,
} from '../../components/Display';
import TaroffTransactionsNew from '../financial/TaroffTransactionsNew';
import TaroffOrdersView from '../orders/TaroffOrdersView';
import { postData, postFile } from '../../Api';

export default function TaroffTransactions(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [balance, setBalance] = useState(null);
    const [appliedFilters, setAppliedFilters] = useState(null);
    const [exporting, setExporting] = useState(false);
    const [exportError, setExportError] = useState('');
    const exportExcel = async () => {
        setExporting(true);
        setExportError('');
        try {
            const blob = await postFile('/api/panel/page/taroff-transactions/export-excel', appliedFilters);
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'account-transactions.xlsx';
            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(() => URL.revokeObjectURL(url), 1000);
        } catch (error) {
            setExportError(typeof error.detail === 'string' ? error.detail : 'دریافت خروجی اکسل ناموفق بود. دوباره تلاش کنید.');
        } finally {
            setExporting(false);
        }
    };
    const handlecomp1 = () => {
        setModal(
            Modal({
                children: <TaroffTransactionsNew onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp2 = () => {
        setModal(
            Modal({
                children: <TaroffTransactionsNew onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp3 = () => {
        applyFilters();
    };
    const [formQShopIdOptions, setFormQShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-transactions/select-data/q-shop-id').then((response) => {
            setFormQShopIdOptions(response.data);
        });
    }, []);
    const [formQUserIdOptions, setFormQUserIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-transactions/select-data/q-user-id').then((response) => {
            setFormQUserIdOptions(response.data);
        });
    }, []);
    const [formQTypeIdOptions, setFormQTypeIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-transactions/select-data/q-type-id').then((response) => {
            setFormQTypeIdOptions(response.data);
        });
    }, []);
    const [formQStateIdOptions, setFormQStateIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-transactions/select-data/q-state-id').then((response) => {
            setFormQStateIdOptions(response.data);
        });
    }, []);
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...Object.fromEntries(searchParams.entries()), page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setTablePage(1);
        setFilterQShopId('');
        setFilterQUserId('');
        setFilterQTypeId('');
        setFilterQTitle('');
        setFilterQInsertTimeFrom('');
        setFilterQInsertTimeTo('');
        setFilterQId('');
        setFilterQStateId('');
        setSearchParams({});
    };
    const applyFilters = () => {
        setTablePage(1);
        const newSearchParams = {};
        filterQShopId && (newSearchParams['q-shop-id'] = filterQShopId);
        filterQUserId && (newSearchParams['q-user-id'] = filterQUserId);
        filterQTypeId && (newSearchParams['q-type-id'] = filterQTypeId);
        filterQTitle && (newSearchParams['q-title'] = filterQTitle);
        filterQInsertTimeFrom && (newSearchParams['q-insert-time-from'] = filterQInsertTimeFrom);
        filterQInsertTimeTo && (newSearchParams['q-insert-time-to'] = filterQInsertTimeTo);
        filterQId && (newSearchParams['q-id'] = filterQId);
        filterQStateId && (newSearchParams['q-state-id'] = filterQStateId);
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    const [filterQShopId, setFilterQShopId] = useState(allProps['q-shop-id'] || '');
    const [filterQUserId, setFilterQUserId] = useState(allProps['q-user-id'] || '');
    const [filterQTypeId, setFilterQTypeId] = useState(allProps['q-type-id'] || '');
    const [filterQTitle, setFilterQTitle] = useState(allProps['q-title'] || '');
    const [filterQInsertTimeFrom, setFilterQInsertTimeFrom] = useState(
        allProps['q-insert-time-from'] || ''
    );
    const [filterQInsertTimeTo, setFilterQInsertTimeTo] = useState(
        allProps['q-insert-time-to'] || ''
    );
    const [filterQId, setFilterQId] = useState(allProps['q-id'] || '');
    const [filterQStateId, setFilterQStateId] = useState(allProps['q-state-id'] || '');
    useEffect(() => {
        let active = true;
        const filters = {
            q_shop_id: filterQShopId,
            q_user_id: filterQUserId,
            q_type_id: filterQTypeId,
            q_title: filterQTitle,
            q_insert_time_from: filterQInsertTimeFrom,
            q_insert_time_to: filterQInsertTimeTo,
            q_id: filterQId,
            q_state_id: filterQStateId,
        };
        setAppliedFilters(null);
        postData('/api/panel/page/taroff-transactions/table-data', {
            ...filters, size: tableSize, page: tablePage,
        }).then((response) => {
            if (active) {
                setTableData(response.data);
                setAppliedFilters(filters);
            }
        }).catch(() => {
            if (active) setTableData({});
        });
        postData('/api/panel/page/taroff-transactions/balance', filters).then((response) => {
            if (active) setBalance(response.balance);
        }).catch(() => {
            if (active) setBalance(null);
        });
        return () => { active = false; };
    }, [searchParams, modal, props]);
    const handlecomp4 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffOrdersView
                        taroff-orders-id={row.param_order_id}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>مدیریت حساب</Title>
                    <TextView>جمع تراز: </TextView>
                    <TextView>{balance?.toLocaleString() ?? '...'}</TextView>
                </RightComponents>
                <LeftComponents>
                    <Button
                        onClick={exportExcel}
                        color={'secondary'}
                        rightIcon={'far fa-file-excel'}
                        disabled={exporting || !appliedFilters}
                        tooltip={'خروجی همه تراکنش‌های مطابق با جستجوی فعلی'}
                    >
                        {exporting ? 'در حال دریافت اکسل…' : 'خروجی اکسل'}
                    </Button>
                    <Button onClick={handlecomp1} color={'secondary'}>
                        ایجاد تراکنش
                    </Button>
                </LeftComponents>
            </Row>
            <Row>
                <RightComponents>
                    <Title>مدیریت حساب</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp2} color={'secondary'}>
                        ایجاد تراکنش
                    </Button>
                    <Button onClick={handlecomp3} color={'secondary'}>
                        جستجو
                    </Button>
                </LeftComponents>
            </Row>
            <RightComponents wrap={true}>
                <MultiSelectBox
                    label={'فروشگاه'}
                    options={formQShopIdOptions}
                    value={filterQShopId}
                    onChange={setFilterQShopId}
                />
                <MultiSelectBox
                    label={'کاربر'}
                    options={formQUserIdOptions}
                    value={filterQUserId}
                    onChange={setFilterQUserId}
                />
                <MultiSelectBox
                    label={'نوع'}
                    options={formQTypeIdOptions}
                    value={filterQTypeId}
                    onChange={setFilterQTypeId}
                />
                <SearchBox onEnter={applyFilters}
                    label={'عنوان'}
                    value={filterQTitle}
                    onChange={setFilterQTitle}
                    width={'120px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان درج از'}
                    value={filterQInsertTimeFrom}
                    onChange={setFilterQInsertTimeFrom}
                    width={'100px'}
                />
                <SearchDateBox onEnter={applyFilters}
                    label={'زمان درج تا'}
                    value={filterQInsertTimeTo}
                    onChange={setFilterQInsertTimeTo}
                    width={'100px'}
                />
                <SearchBox onEnter={applyFilters}
                    label={'شناسه'}
                    value={filterQId}
                    onChange={setFilterQId}
                    width={'120px'}
                />
                <MultiSelectBox
                    label={'وضعیت'}
                    options={formQStateIdOptions}
                    value={filterQStateId}
                    onChange={setFilterQStateId}
                />
                <Button rightIcon={'far fa-search'} onClick={applyFilters}>
                    جستجو
                </Button>
                <Button rightIcon={'far fa-trash'} onClick={clearFilters}>
                    پاک کردن
                </Button>
            </RightComponents>
            {exportError && <div role="alert">{exportError}</div>}
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>ردیف</TableColumn>
                        <TableColumn mobile={false}>فروشگاه</TableColumn>
                        <TableColumn mobile={false}>نام کاربری</TableColumn>
                        <TableColumn mobile={false}>شناسه سفارش</TableColumn>
                        <TableColumn mobile={false}>نوع تراکنش</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>مبلغ</TableColumn>
                        <TableColumn mobile={false}>زمان درج</TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_shop_id_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_user_id_username}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <RightComponents>
                                    <TextView>{row.text_order_id_id}</TextView>
                                    <TextView>{row.text}</TextView>
                                    <TextView format={'persian-date-normal'}>
                                        {row.text_order_id_insert_time}
                                    </TextView>
                                </RightComponents>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView backColor={row.color_type_id_color}>
                                    {row.text_type_id_title}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'money'}>{row.text_amount}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <Row>
                                    <RightComponents>
                                        <TextView format={'persian-datetime-normal'}>
                                            {row.text_insert_time}
                                        </TextView>
                                    </RightComponents>
                                    <LeftComponents>
                                        {row.show && (
                                            <Button
                                                onClick={() => handlecomp4(row)}
                                                color={'accent'}
                                                rightIcon={'fad fa-abacus'}
                                                tooltip={'سفارش'}
                                            ></Button>
                                        )}
                                    </LeftComponents>
                                </Row>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
